import "../css/CentralCatalogProvider.css";

export default ({ logo, text, enabled, onClick }) => {
  return (
    <div
      className={`central-catalog-provider${enabled ? " central-catalog-provider-selected" : ""}`}
      onClick={onClick}
    >
      <img className="central-catalog-provider-logo" src={logo} alt="" />
      {text && <span className="central-catalog-provider-text">{text}</span>}
    </div>
  );
};
